import React, { FC } from "react";
import { createStackNavigator } from "@react-navigation/stack";

import BrandList from "../components/brand/brandList";
import AddEditBrand from "../components/brand/addEditBrand";
import ViewProduct from "../components/brand/viewProduct";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const BrandStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"BrandList"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="BrandList" component={BrandList} />
            <AppStack.Screen name="AddEditBrand" component={AddEditBrand} />
            <AppStack.Screen name="AllProductList" component={ViewProduct} />
        </AppStack.Navigator>
    );
};

export default BrandStack;